<div *ngIf="userInfo">
<ngx-charts-pie-chart
    [view]="view"
    [scheme]="colorScheme"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [labels]="showLabels"
    [results]="data"
    (select)="onSelect($event)"
    (activate)="onActivate($event)"
    (deactivate)="onDeactivate($event)"
>
</ngx-charts-pie-chart>
</div>
